<div class="gotop">
  <app-headerbilliard></app-headerbilliard>
</div>
<app-firstbilliard></app-firstbilliard>
<app-divbilliard></app-divbilliard>
<app-secondbilliard></app-secondbilliard>
<app-divtech></app-divtech>
<app-questions></app-questions>
